/**
 * Variant Title Updater
 * Updates the product title when the variant changes
 */
document.addEventListener('DOMContentLoaded', function() {
  console.log('Variant Title Updater: Initializing');
  setupVariantTitleUpdater();
  hookIntoThemeVariantSelection();
});

function setupVariantTitleUpdater() {
  // Listen for variant change events - multiple possible event types
  document.addEventListener('variant:changed', function(event) {
    console.log('Variant Title Updater: variant:changed event detected', event);
    handleVariantChange(event);
  });
  
  document.addEventListener('variantChanged', function(event) {
    console.log('Variant Title Updater: variantChanged event detected', event);
    handleVariantChange(event);
  });
  
  // Listen for changes to the variant selector
  const variantSelectors = document.querySelectorAll('[name="id"], .ProductForm__Variants select, .OptionSelector select');
  console.log('Variant Title Updater: Found variant selectors:', variantSelectors.length);
  
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function(event) {
      console.log('Variant Title Updater: Selector change detected', event.target.value);
      setTimeout(checkCurrentVariant, 10);
    });
  });
  
  // Listen for changes to option selectors (this is how most Shopify themes handle variant selection)
  const optionSelectors = document.querySelectorAll('.SizeSwatchList .SizeSwatch, .ColorSwatchList .ColorSwatch, [data-option-position]');
  console.log('Variant Title Updater: Found option selectors:', optionSelectors.length);
  
  optionSelectors.forEach(selector => {
    selector.addEventListener('click', function(event) {
      console.log('Variant Title Updater: Option selector clicked', event.target);
      // Give the theme time to update the variant
      setTimeout(checkCurrentVariant, 100);
    });
  });
  
  // Also set up a MutationObserver to watch for DOM changes that might indicate a variant change
  const productForm = document.querySelector('.ProductForm');
  if (productForm) {
    console.log('Variant Title Updater: Setting up MutationObserver on ProductForm');
    const observer = new MutationObserver(function(mutations) {
      console.log('Variant Title Updater: DOM mutation detected', mutations);
      checkCurrentVariant();
    });
    
    observer.observe(productForm, {
      attributes: true,
      childList: true,
      subtree: true
    });
  } else {
    console.log('Variant Title Updater: ProductForm not found');
  }
  
  // Initial check
  console.log('Variant Title Updater: Scheduling initial check');
  setTimeout(checkCurrentVariant, 500);
  
  // Also check periodically
  setInterval(checkCurrentVariant, 1000);
}

function handleVariantChange(event) {
  if (!event || !event.detail) {
    console.log('Variant Title Updater: Invalid event or missing detail', event);
    return;
  }
  
  const variant = event.detail.variant;
  if (!variant) {
    console.log('Variant Title Updater: No variant in event detail', event.detail);
    return;
  }
  
  console.log('Variant Title Updater: Handling variant change', variant);
  updateTitleForVariant(variant.id);
}

function checkCurrentVariant() {
  // Get the currently selected variant ID
  const variantInput = document.querySelector('[name="id"]:checked, [name="id"]');
  if (variantInput) {
    const variantId = variantInput.value;
    if (variantId) {
      console.log('Variant Title Updater: Current variant ID', variantId);
      updateTitleForVariant(parseInt(variantId));
    } else {
      console.log('Variant Title Updater: Variant input has no value');
    }
  } else {
    console.log('Variant Title Updater: No variant input found');
  }
}

function updateTitleForVariant(variantId) {
  console.log('Variant Title Updater: Updating title for variant', variantId);
  
  // First try to get variant data from the window.meta object
  if (window.meta && window.meta.product && window.meta.product.variants) {
    console.log('Variant Title Updater: Using window.meta data');
    const variantData = window.meta.product.variants.find(v => v.id === variantId);
    if (variantData && variantData.metafields && variantData.metafields.custom && variantData.metafields.custom.Alt_Title) {
      console.log('Variant Title Updater: Found Alt_Title in window.meta', variantData.metafields.custom.Alt_Title);
      updateProductTitle(variantData.metafields.custom.Alt_Title);
      return;
    }
  }
  
  // Check for variant metafields in the DOM
  const variantMetafieldsElement = document.querySelector(`[data-variant-metafields="${variantId}"]`);
  if (variantMetafieldsElement) {
    console.log('Variant Title Updater: Found variant metafields element in DOM');
    try {
      const metafields = JSON.parse(variantMetafieldsElement.textContent);
      if (metafields && metafields.custom && metafields.custom.Alt_Title) {
        console.log('Variant Title Updater: Found Alt_Title in DOM metafields', metafields.custom.Alt_Title);
        updateProductTitle(metafields.custom.Alt_Title);
        return;
      }
    } catch (e) {
      console.error('Variant Title Updater: Error parsing variant metafields', e);
    }
  } else {
    console.log('Variant Title Updater: No variant metafields element found in DOM');
  }
  
  // If that fails, try to get it from the product JSON
  const variantJson = document.getElementById('ProductJson-product-template') || 
                      document.getElementById('ProductJson-template') || 
                      document.getElementById('ProductJson');
  
  if (variantJson) {
    console.log('Variant Title Updater: Found product JSON');
    try {
      const productData = JSON.parse(variantJson.textContent);
      console.log('Variant Title Updater: Reverting to product title', productData.title);
      updateProductTitle(productData.title);
    } catch (e) {
      console.error('Variant Title Updater: Error parsing product JSON', e);
    }
  } else {
    console.log('Variant Title Updater: No product JSON found');
  }
}

function updateProductTitle(title) {
  if (!title) {
    console.log('Variant Title Updater: No title provided');
    return;
  }
  
  console.log('Variant Title Updater: Updating title to', title);
  
  // Find the product title element
  const titleElements = document.querySelectorAll('.ProductMeta__Title');
  console.log('Variant Title Updater: Found title elements', titleElements.length);
  
  titleElements.forEach(element => {
    element.textContent = title;
  });
}

function hookIntoThemeVariantSelection() {
  // Wait for the theme's JavaScript to load
  setTimeout(function() {
    // Try to hook into the theme's selectVariant function
    if (window.ProductVariant && window.ProductVariant.prototype && window.ProductVariant.prototype._updateSelectedVariant) {
      console.log('Variant Title Updater: Hooking into ProductVariant._updateSelectedVariant');
      
      // Store the original function
      const originalUpdateSelectedVariant = window.ProductVariant.prototype._updateSelectedVariant;
      
      // Override the function
      window.ProductVariant.prototype._updateSelectedVariant = function() {
        // Call the original function
        const result = originalUpdateSelectedVariant.apply(this, arguments);
        
        // Get the selected variant
        const selectedVariant = this.selectedVariant;
        console.log('Variant Title Updater: _updateSelectedVariant called, selected variant:', selectedVariant);
        
        if (selectedVariant) {
          // Update the title
          updateTitleForVariant(selectedVariant.id);
        }
        
        return result;
      };
    } else {
      console.log('Variant Title Updater: Could not hook into ProductVariant._updateSelectedVariant');
    }
    
    // Try another approach - hook into the global selectCallback function
    if (window.selectCallback) {
      console.log('Variant Title Updater: Hooking into selectCallback');
      
      // Store the original function
      const originalSelectCallback = window.selectCallback;
      
      // Override the function
      window.selectCallback = function(variant, selector) {
        // Call the original function
        const result = originalSelectCallback.apply(this, arguments);
        
        console.log('Variant Title Updater: selectCallback called, variant:', variant);
        
        if (variant) {
          // Update the title
          updateTitleForVariant(variant.id);
        }
        
        return result;
      };
    } else {
      console.log('Variant Title Updater: Could not hook into selectCallback');
    }
  }, 1000);
} 